/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { TILE_LIMIT, TILE_TYPE } from '../../core/Constants';
import {
  prioritizedListNotifications, showingTileNotifications
} from '../../components/NotificationSection/NotificationSection';
import {
  prioritizedListPromotions, showingTilePromotions
} from '../../components/PromotionSection/PromotionSection';

// Utility methods
const removeEmptyElementsFromSection = (list) => {
  return list.filter(Boolean);
};

const createListOfSectionTiles = (section, elementList) => {
  return elementList.map((element) => {
    return { section, element };
  });
};

const reduceSectionTiles = (tiles, section, sectionTiles) => {
  if (section === TILE_TYPE.NOTIFICATION) {
    sectionTiles.splice(TILE_LIMIT);
  }
  if (section === TILE_TYPE.PROMOTION) {
    const spaceRemaining = TILE_LIMIT - tiles[TILE_TYPE.NOTIFICATION].length;
    sectionTiles.splice(spaceRemaining);
  }
  return sectionTiles;
};

const displayTilesForSection = (section, tiles) => {
  return tiles?.map((tile, idx) => (
    <React.Fragment key={`${section}_${idx}`}>
      {tile.element}
    </React.Fragment>
  )) || <></>;
};

export const RenderNotificationTiles = (prioritizedList) => {
  const section = TILE_TYPE.NOTIFICATION;
  const filteredTiles = prioritizedList.filter(Boolean);
  let sectionTiles = createListOfSectionTiles(section, filteredTiles);
  sectionTiles.splice(TILE_LIMIT);
  return displayTilesForSection(section, sectionTiles) || <></>;
};
export const RenderPromotionTiles = (notifList, prioritizedList) => {
  const section = TILE_TYPE.PROMOTION;
  const filteredTiles = prioritizedList.filter(Boolean);
  let sectionTiles = createListOfSectionTiles(section, filteredTiles);
  const spaceRemaining = TILE_LIMIT - notifList?.length;
  sectionTiles.splice(spaceRemaining);
  return displayTilesForSection(section, sectionTiles) || <></>;
};

export const createTiles = ({
  isAdmin, userData, availablePerksData, isLoadingPerks, refreshAvailablePerks, availablePerksError
}) => {
  const showingTile = {
    NOTIFICATION: showingTileNotifications({ isAdmin, userData, availablePerksData }),
    PROMOTION: showingTilePromotions({ isAdmin, userData }),
  };
  const prioritizedList = {
    NOTIFICATION: prioritizedListNotifications({
      showingTile: showingTile.NOTIFICATION,
      userData,
      availablePerksData,
      isLoadingPerks,
      refreshAvailablePerks,
      availablePerksError
    }),
    PROMOTION: prioritizedListPromotions({ showingTile: showingTile.PROMOTION, userData }),
  };
  const renderedNotifications = RenderNotificationTiles(prioritizedList.NOTIFICATION);
  const renderedPromotions = RenderPromotionTiles(renderedNotifications, prioritizedList.PROMOTION);
  return { NOTIFICATION: renderedNotifications, PROMOTION: renderedPromotions };
};

export const exportsForTesting = {
  removeEmptyElementsFromSection,
  createListOfSectionTiles,
  reduceSectionTiles,
  displayTilesForSection,
};